module.exports = __webpack_public_path__ + "static/media/tink-connector.0ca0b5ea.png";